
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gwYznzMWf1wKG_yDLbaSeqF7rATWfsXQVpyG7vNSaPpMMeta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexVy6MOc4GaMhi6WtWS1PP4IHQtHKwOE0ihDRRco9O0jcMeta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchV_WgTmOtfBFhzznXHIsvqtVhBVvbOf8o1i2xJxgg3xcMeta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexOnE_e4EuvSmxTcmzxKsOL2cTGLM9AWRfRPBUlJLoqGAMeta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_93QfbaJTIqFME7JSApmflReOqszU8SpTuayG5KN6LNf8IMeta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexWrnWTT3KN_45MDQJ_45ERSi9o1OnuDk_45bKbV1ZBXrJim9rIMeta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93thT3JytVIALautjK0kZGCGqi0_Xwsk8aS69iwz_45mhxkMeta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as index0vXUcD0y_PQxOZdnvQPXl_cesezo_45gl1mXvIYSld4A0Meta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_933sXA_pKori_45lijeZS8vC4rQ6bAqNA_PlNbnnZwBWxVkMeta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexKA7hHjANVImmcscgR9LlXVjcAoYvUBs_45_K0CSwQMTmgMeta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as index_45pNkrLt5DGHcMwYtkzJW5kGTlL4jg5PZKULXNAUnczcMeta } from "/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexWrnWTT3KN_45MDQJ_45ERSi9o1OnuDk_45bKbV1ZBXrJim9rIMeta || {},
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: index0vXUcD0y_PQxOZdnvQPXl_cesezo_45gl1mXvIYSld4A0Meta || {},
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexKA7hHjANVImmcscgR9LlXVjcAoYvUBs_45_K0CSwQMTmgMeta || {},
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: index_45pNkrLt5DGHcMwYtkzJW5kGTlL4jg5PZKULXNAUnczcMeta || {},
    component: () => import("/codebuild/output/src1530129477/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]